// extracted by mini-css-extract-plugin
export default {"page":"h1-z","cartModal":"i1-z","checkout":"j1-z","placeholder":"k1-z","account":"l1-z"};